import * as React from 'react';
import Step1 from "./views/steps/Step1";
import Step2 from "./views/steps/Step2";
import {useDispatch, useSelector} from "react-redux";
import {selectRequestState, setData, setItem} from "./store/request/stateSlice";
import Step3Check from "./views/steps/Step3Check";
import Box from "@mui/material/Box";
import Step3Login from "./views/steps/Step3Login";
import Step4 from "./views/steps/Step4";
import Step3Register from "./views/steps/Step3Register";
import Step3Recover from "./views/steps/Step3Recover";
import {useEffect} from "react";
import Api from "./inc/Api";
import {CircularProgress} from "@mui/material";
import {DEBUG} from "./inc/Config";
import Step6Paid from "./views/steps/Step6Paid";
import Step5PayCard from "./views/steps/Step5PayCard";
import Step5Prepaid from "./views/steps/Step5Prepaid";

export default function App() {

    const state = useSelector(selectRequestState);
    const dispatch = useDispatch();

    useEffect(loadData, []);

    const addHours = (date, hours) => {
        date.setHours(date.getHours() + hours);
        return date;
    };

    const formatDateToMySQL = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    function loadData() {
        Api.get(`/widgets/1`, rsp => {
            if (rsp.ok) {
                dispatch(setData(rsp));
                if (rsp.locations.length == 1) {
                    dispatch(setItem({
                        id_widget: rsp.item.id,
                        dst      : {
                            lat    : rsp.locations[0].lat,
                            lng    : rsp.locations[0].lng,
                            address: rsp.locations[0].address,
                        },
                    }));
                }

                // modo pruebas
                if (DEBUG) {
                    let start_part_date = formatDateToMySQL(addHours(new Date(), 24));
                    let start_part_time = '08:00:00';
                    let return_part_date = formatDateToMySQL(addHours(new Date(), 24));
                    let return_part_time = '08:00:00';
                    dispatch(setItem({
                        org        : {
                            lat    : -12.0655929,
                            lng    : -76.9653649,
                            address: 'ToolRides',
                        },
                        start_part_date,
                        start_part_time,
                        return_part_date,
                        return_part_time,
                        date_start : `${start_part_date} ${start_part_time}`,
                        date_return: `${return_part_date} ${return_part_time}`,
                        client     : {
                            email: 'demo@demo.com',
                        },
                    }));
                }

            } else {
                // algo pasó...
            }
        });
    }

    if (state.data) {
        switch (state.step) {
            case '1':
                return <Step1/>;
            case '2':
                return <Step2/>;
            case '3_check':
                return <Step3Check/>;
            case '3_login':
                return <Step3Login/>;
            case '3_recover':
                return <Step3Recover/>;
            case '3_register':
                return <Step3Register/>;
            case '4':
                return <Step4/>;
            case '5_pay_card':
                return <Step5PayCard/>;
            case '5_prepaid':
                return <Step5Prepaid/>;
            case '6_paid':
                return <Step6Paid/>;
            default:
                return <Box/>;
        }
    } else {
        return (
            <Box textAlign="center" py={8}>
                <CircularProgress color="secondary"/>
            </Box>
        )
    }
}
